function convert_price_to_usd(price,cero=false)
{        
	var array_number=price.toString().split("");
	array_number.reverse();
	var new_price="";
	var coma="";
	var count=0;
	var limit=array_number.length-1;


	if(cero)
	{
		initial=0;
		array_number.forEach(function(num,i)
		{
			if(i<=1)
			{
				new_price+=num;
			}
		});		
		new_price+=".";
	}	

	array_number.forEach(function(num,i)
	{
		if(i>1)
		{
			count+=1;
		if(count>=3 && i<limit)
			{
				coma=",";
				count=0;
			}     
			new_price+=num+coma;
			coma="";
		}
	});
	array_number=new_price.toString().split("");
	array_number.reverse();
	new_price="";

	array_number.forEach(function(num,i)
	{
	new_price+=num;
	});
	return new_price;
} 